import * as Types from '../../../../../../../__generated__/base.gql';

import { gql } from '@apollo/client';
import { CareEventDiagnosisFragmentDoc } from '../../../../inpatient/_lib/__generated__/queries.gql';
import { PatientCurrentVisitFragmentDoc } from '../../../../_lib/__generated__/details-graphql.gql';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type InpatientHistoryQueryVariables = Types.Exact<{
  input: Types.PastInpatientVisitsInput;
}>;


export type InpatientHistoryQuery = { readonly __typename?: 'Query', readonly pastInpatientVisits?: { readonly __typename?: 'PaginatedVisits', readonly hasMore: boolean, readonly limit: number, readonly offset: number, readonly total: number, readonly items: ReadonlyArray<{ readonly __typename?: 'Visit', readonly _id: string, readonly admissionEvent?: { readonly __typename?: 'VisitCareEvent', readonly _id?: string | null, readonly type?: Types.VisitCareEventAction | null, readonly created?: string | null, readonly notes?: string | null, readonly performer?: { readonly __typename?: 'VisitElephantActor', readonly _id: string, readonly name: string } | null, readonly diagnosisList?: ReadonlyArray<{ readonly __typename?: 'Diagnosis', readonly type?: Types.DiagnosisType | null, readonly uuid?: string | null, readonly notes?: string | null, readonly diseaseSnapshot?: unknown | null } | null> | null } | null, readonly dischargeEvent?: { readonly __typename?: 'VisitCareEvent', readonly _id?: string | null, readonly type?: Types.VisitCareEventAction | null, readonly created?: string | null, readonly notes?: string | null, readonly performer?: { readonly __typename?: 'VisitElephantActor', readonly _id: string, readonly name: string } | null, readonly diagnosisList?: ReadonlyArray<{ readonly __typename?: 'Diagnosis', readonly type?: Types.DiagnosisType | null, readonly uuid?: string | null, readonly notes?: string | null, readonly diseaseSnapshot?: unknown | null } | null> | null } | null, readonly meta?: { readonly __typename?: 'VisitMeta', readonly created?: string | null } | null } | null> } | null };

export type OnlinePatientHistoryDetailsQueryVariables = Types.Exact<{
  id: Types.Scalars['String'];
}>;


export type OnlinePatientHistoryDetailsQuery = { readonly __typename?: 'Query', readonly patientByCardId?: { readonly __typename?: 'PatientByCardIdResult', readonly passportId?: string | null, readonly patient: { readonly __typename?: 'Patient', readonly currentVisit?: { readonly __typename?: 'Visit', readonly _id: string, readonly expiryStrategy?: Types.VisitExpiryStrategy | null, readonly admissionEvent?: { readonly __typename?: 'VisitCareEvent', readonly _id?: string | null, readonly type?: Types.VisitCareEventAction | null } | null, readonly insuranceList?: ReadonlyArray<{ readonly __typename?: 'InsuranceListItem', readonly isValidForVisit?: boolean | null, readonly visitInsuranceDetails?: unknown | null, readonly insurance: { readonly __typename?: 'VisitInsurance', readonly insuranceProvider?: { readonly __typename?: 'InsuranceProvider', readonly name?: string | null, readonly insuranceType?: string | null, readonly visitValidation?: { readonly __typename?: 'InsuranceVisitValidation', readonly expiryStrategy: Types.VisitExpiryStrategy } | null } | null } } | null> | null } | null, readonly card?: { readonly __typename?: 'PatientCard', readonly id?: string | null } | null } } | null };

export type UsersByIdQueryVariables = Types.Exact<{
  ids: ReadonlyArray<Types.InputMaybe<Types.Scalars['String']>> | Types.InputMaybe<Types.Scalars['String']>;
}>;


export type UsersByIdQuery = { readonly __typename?: 'Query', readonly usersById?: ReadonlyArray<{ readonly __typename?: 'User', readonly _id: string, readonly person?: { readonly __typename?: 'UserPerson', readonly firstname?: string | null, readonly lastname?: string | null } | null } | null> | null };


export const InpatientHistoryDocument = gql`
    query InpatientHistory($input: PastInpatientVisitsInput!) {
  pastInpatientVisits(input: $input) {
    items {
      _id
      admissionEvent {
        _id
        type
        created
        notes
        performer {
          _id
          name
        }
        ...CareEventDiagnosis
      }
      dischargeEvent {
        _id
        type
        created
        notes
        performer {
          _id
          name
        }
        ...CareEventDiagnosis
      }
      meta {
        created
      }
    }
    hasMore
    limit
    offset
    total
  }
}
    ${CareEventDiagnosisFragmentDoc}`;

/**
 * __useInpatientHistoryQuery__
 *
 * To run a query within a React component, call `useInpatientHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useInpatientHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInpatientHistoryQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInpatientHistoryQuery(baseOptions: Apollo.QueryHookOptions<InpatientHistoryQuery, InpatientHistoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InpatientHistoryQuery, InpatientHistoryQueryVariables>(InpatientHistoryDocument, options);
      }
export function useInpatientHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InpatientHistoryQuery, InpatientHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InpatientHistoryQuery, InpatientHistoryQueryVariables>(InpatientHistoryDocument, options);
        }
export type InpatientHistoryQueryHookResult = ReturnType<typeof useInpatientHistoryQuery>;
export type InpatientHistoryLazyQueryHookResult = ReturnType<typeof useInpatientHistoryLazyQuery>;
export type InpatientHistoryQueryResult = Apollo.QueryResult<InpatientHistoryQuery, InpatientHistoryQueryVariables>;
export const OnlinePatientHistoryDetailsDocument = gql`
    query OnlinePatientHistoryDetails($id: String!) {
  patientByCardId(uuid: $id) {
    passportId
    patient {
      currentVisit {
        ...PatientCurrentVisit
      }
      card {
        id
      }
    }
  }
}
    ${PatientCurrentVisitFragmentDoc}`;

/**
 * __useOnlinePatientHistoryDetailsQuery__
 *
 * To run a query within a React component, call `useOnlinePatientHistoryDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOnlinePatientHistoryDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnlinePatientHistoryDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOnlinePatientHistoryDetailsQuery(baseOptions: Apollo.QueryHookOptions<OnlinePatientHistoryDetailsQuery, OnlinePatientHistoryDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OnlinePatientHistoryDetailsQuery, OnlinePatientHistoryDetailsQueryVariables>(OnlinePatientHistoryDetailsDocument, options);
      }
export function useOnlinePatientHistoryDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OnlinePatientHistoryDetailsQuery, OnlinePatientHistoryDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OnlinePatientHistoryDetailsQuery, OnlinePatientHistoryDetailsQueryVariables>(OnlinePatientHistoryDetailsDocument, options);
        }
export type OnlinePatientHistoryDetailsQueryHookResult = ReturnType<typeof useOnlinePatientHistoryDetailsQuery>;
export type OnlinePatientHistoryDetailsLazyQueryHookResult = ReturnType<typeof useOnlinePatientHistoryDetailsLazyQuery>;
export type OnlinePatientHistoryDetailsQueryResult = Apollo.QueryResult<OnlinePatientHistoryDetailsQuery, OnlinePatientHistoryDetailsQueryVariables>;
export const UsersByIdDocument = gql`
    query usersById($ids: [String]!) {
  usersById(ids: $ids) {
    _id
    person {
      firstname
      lastname
    }
  }
}
    `;

/**
 * __useUsersByIdQuery__
 *
 * To run a query within a React component, call `useUsersByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsersByIdQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useUsersByIdQuery(baseOptions: Apollo.QueryHookOptions<UsersByIdQuery, UsersByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UsersByIdQuery, UsersByIdQueryVariables>(UsersByIdDocument, options);
      }
export function useUsersByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UsersByIdQuery, UsersByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UsersByIdQuery, UsersByIdQueryVariables>(UsersByIdDocument, options);
        }
export type UsersByIdQueryHookResult = ReturnType<typeof useUsersByIdQuery>;
export type UsersByIdLazyQueryHookResult = ReturnType<typeof useUsersByIdLazyQuery>;
export type UsersByIdQueryResult = Apollo.QueryResult<UsersByIdQuery, UsersByIdQueryVariables>;